module.exports = __webpack_public_path__ + "static/media/salesforce.7b6a016e.png";